/* import __COLOCATED_TEMPLATE__ from './empty-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();